var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit" },
    [
      _c("Grid", {
        attrs: {
          module: _vm.module,
          data: _vm.classes,
          columns: _vm.columnOptions,
          onLaunch: _vm.selectClass,
          onRequest: _vm.fetchInstructorClasses,
          loading: _vm.userClassesLoading
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }